import { FileText, AlertCircle } from 'lucide-react';

const CourseTerms = () => {
  return (
    <div className="min-h-screen py-24" data-testid="course-terms-page">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="text-center mb-12">
          <FileText size={48} className="mx-auto mb-4" style={{ color: '#D4AF37' }} />
          <h1 className="text-4xl font-bold mb-4" style={{ color: '#ffffff' }}>
            Course Purchase Terms & Conditions
          </h1>
          <p className="text-muted-foreground">Last updated: January 2025</p>
        </div>

        {/* Important Notice */}
        <div className="rounded-2xl p-6 border mb-8" style={{ background: 'rgba(239, 68, 68, 0.1)', borderColor: 'rgba(239, 68, 68, 0.3)' }}>
          <div className="flex items-start gap-4">
            <AlertCircle size={24} style={{ color: '#ef4444' }} className="flex-shrink-0 mt-1" />
            <div>
              <h3 className="font-bold text-lg mb-2" style={{ color: '#ef4444' }}>Important: No Refunds on One-Time Purchases</h3>
              <p style={{ color: '#fca5a5' }}>
                All one-time course purchases are final and non-refundable. Please review the course content and requirements carefully before purchasing. By completing your purchase, you acknowledge and agree to this no-refund policy.
              </p>
            </div>
          </div>
        </div>

        <div className="glass-panel rounded-2xl p-8 border space-y-8">
          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>1. Course Description</h2>
            <p className="text-muted-foreground leading-relaxed">
              The 30-Day Beginner DJ Course is a comprehensive self-paced learning program designed to teach the fundamentals of DJing. The course includes video lessons, quizzes, downloadable resources, and lifetime access to course materials upon purchase.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>2. Purchase & Payment</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>The course is available as a one-time purchase of £45.99.</li>
              <li>Payment is processed securely through Stripe.</li>
              <li>Upon successful payment, you will receive immediate access to all course content.</li>
              <li>A purchase confirmation will be sent to your registered email address.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>3. Refund Policy</h2>
            <div className="p-4 rounded-lg mb-4" style={{ background: 'rgba(212, 175, 55, 0.1)' }}>
              <p className="font-semibold" style={{ color: '#D4AF37' }}>
                No refunds are available on one-time course purchases.
              </p>
            </div>
            <p className="text-muted-foreground leading-relaxed">
              Due to the digital nature of our course content and the immediate access granted upon purchase, all sales are final. We encourage you to review the course curriculum and sample content available on our website before making a purchase decision.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>4. Lifetime Access</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>Your purchase grants you lifetime access to the course content.</li>
              <li>You also receive permanent "Starter" membership tier access as part of your purchase.</li>
              <li>Access includes all future updates and additions to the course material.</li>
              <li>Content access is tied to your registered account.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>5. Certificate of Completion</h2>
            <p className="text-muted-foreground leading-relaxed">
              Upon completing at least 95% of the course lessons, you will be eligible to download an official Blendonics Certificate of Completion. This certificate is a PDF document that can be shared on professional networks and social media.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>6. Intellectual Property</h2>
            <ul className="text-muted-foreground leading-relaxed space-y-2 list-disc list-inside">
              <li>All course content, including videos, text, graphics, and downloadable materials, is owned by Blendonics.</li>
              <li>Your purchase grants you a personal, non-transferable license to access and use the content.</li>
              <li>You may not reproduce, distribute, or share course content without written permission.</li>
              <li>Screen recording or downloading of video content for redistribution is prohibited.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>7. Technical Requirements</h2>
            <p className="text-muted-foreground leading-relaxed">
              To access the course, you will need a stable internet connection and a modern web browser. While DJ equipment is helpful for practice, it is not required to begin the course. The course can be accessed on desktop and mobile devices.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mb-4" style={{ color: '#D4AF37' }}>8. Contact Us</h2>
            <p className="text-muted-foreground leading-relaxed">
              For questions about your course purchase or technical support, please contact us at{' '}
              <a href="mailto:contact@blendonics.com" style={{ color: '#D4AF37' }}>contact@blendonics.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CourseTerms;
